import React from 'react';

import { useTranslation } from 'react-i18next';

import { calculateY } from '../helpers';
import getOrdinal from '../../../../../helpers/getOrdinal';

export default function Explanation({
  value,
  values,
  percentageInputField,
  settingField,
  beforeAfterField,
  numberInputField,
}) {
  const { t } = useTranslation();

  const setting = value?.[settingField?.name];
  const beforeAfter = value?.[beforeAfterField?.name];
  const loanPaymentDueDay = values.due_day;
  const dayOffset = value?.[numberInputField?.name];

  if (!setting || !beforeAfter || dayOffset === undefined || dayOffset === '') {
    return null;
  }

  const isZeroDay = +dayOffset === 0 && setting === 'offset';

  let content = '';

  if (beforeAfter === 'on') {
    content = `${value?.[percentageInputField?.name] || ''}% ${t(
      'Form.NumberPercentageArray.Form.Explanation.of the payment will be initiated on the'
    )} ${getOrdinal(loanPaymentDueDay)} ${t(
      'Form.NumberPercentageArray.Form.Explanation.day'
    )}.`;
  } else {
    content = (
      <>
        {value?.[percentageInputField?.name]}%{' '}
        {t(
          'Form.NumberPercentageArray.Form.Explanation.of the payment will be initiated on'
        )}{' '}
        {calculateY({
          setting,
          beforeAfter,
          loanPaymentDueDay,
          dayOffset,
        })}{' '}
        {t('Form.NumberPercentageArray.Form.Explanation.day of the month')}{' '}
        {isZeroDay
          ? 'on'
          : `${t(
              `Form.NumberPercentageArray.Form.Explanation.${
                value?.[beforeAfterField?.name]
              }`
            )}`}{' '}
        {t('Form.NumberPercentageArray.Form.Explanation.the due date')}.
      </>
    );
  }

  return <div className="flex items-end italic mt-2">{content}</div>;
}

// ${
//  beforeAfter === 'on' ? 'max-w-[370px]' : ''
//      }
